<template>
  <button
    class="cj-button"
    :class="{ fat, pressed }"
    :disabled="disabled"
    @touchstart="pressed = true"
    @touchend="pressed = false"
    @mousedown="pressed = true"
    @mouseup="pressed = false"
    @mouseleave="pressed = false"
    @click="$emit('click', $event)"
  >
    <div class="bg-fallback" />
    <div class="bg">
      <slot />
    </div>
  </button>
</template>

<script>
import { contains } from 'ramda'

export default {
  name: 'CJButton',

  props: {
    fat: Boolean,

    type: {
      type: String,
      default: 'button',
      validator: value => contains(value, [ 'button', 'submit', 'reset' ]),
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      pressed: false,
    }
  },
}
</script>

<style lang="stylus" scoped>
  button.cj-button
    position: relative
    outline: none
    color: white
    text-transform: uppercase
    font-weight: 700
    font-size: 20px
    font-family: 'Futura Std Condensed'

    &:not([disabled])
      cursor: pointer

    &[disabled]
      color: rgba(255, 255, 255, 0.6)

    .bg-fallback
      position: absolute
      top: 1px
      left: 2px
      width: 314px
      height: 37px
      background-color: #951210

    .bg
      position: absolute
      top: 0
      left: 3px
      line-height: 2.3

    &.fat
      font-size: 28px

      .bg-fallback
        top: 2px
        left: 4px
        width: 239px
        height: 47px

      .bg
        line-height: 1.95

      &.pressed
        .bg
          background: none
</style>
